<template>
  <transition name="modal" v-if="isInitialized">
    <div class="modalcon">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container" @click.stop>
            <div v-if="showMap">
              <div class="modal-header">
                <h5>Select Delivery Location</h5>
                <div class="closebtn" @click="$emit('close')">X</div>
              </div>
              <div class="input-container">
                <i class="fa fa-search search-icon"></i>
                <input
                  id="autocomplete"
                  type="text"
                  placeholder="Search for area, street name, locality..."
                  class="search-input"
                  v-model="inputValue"
                  @input="onInputChange"
                />
                <!-- Suggestions dropdown -->
                <ul v-if="predictions.length" class="suggestions-list">
                  <li
                    v-for="(prediction, index) in predictions"
                    :key="index"
                    @click="selectSuggestion(prediction)"
                    class="suggestion-item"
                  >
                    {{ prediction.description }}
                  </li>
                </ul>
              </div>
            <div class="modal-body text-center">
              <!-- Map Section -->
              <div style="width: 100%; height: 300px;" class="mb-3" ref="mapContainer"></div>
              <img
                :src="crooshair"
                alt="Map Marker"
                @click="recenterMarkerToCurrentLocation"
                title="Go to current location"
                style="position: absolute; right: 8px; top: 180px; width: 60px; height: 60px; cursor: pointer; z-index: 5;"
              />
              <div v-if="locationInfo" class="text-left p-1 rounded shadow-sm bg-white" >
                <div class="d-flex align-items-center mb-2" style="gap: 8px;">
                  <img :src="pinDropIcon" alt="Map Marker" style="width: 12px; height: 16px;"  />
                  <strong class="h6 m-0">
                    {{
                      (addressInfo.route && addressInfo.route.toLowerCase() !== 'unnamed road' ? addressInfo.route : '') ||
                      addressInfo.sublocality_level_1 ||
                      addressInfo.sublocality_level_2 ||
                      addressInfo.sublocality_level_3 ||
                      addressInfo.locality ||
                      addressInfo.administrative_area_level_1 ||
                      addressInfo.administrative_area_level_2 ||
                      addressInfo.administrative_area_level_3 ||
                      'Area Name'
                    }}
                  </strong>
                  <!-- <strong class="h6 m-0">{{ addressInfo.route || addressInfo.sublocality_level_1 || addressInfo.sublocality_level_2 || addressInfo.sublocality_level_3 || addressInfo.locality || addressInfo.administrative_area_level_1 || addressInfo.administrative_area_level_2 || addressInfo.administrative_area_level_3 || 'Area Name' }}</strong> -->
                </div>
                <p class="text-muted px-2 mb-0" style="line-height: 1.4;">
                {{
                  [
                    addressInfo.sublocality_level_3,
                    addressInfo.sublocality_level_2,
                    addressInfo.sublocality_level_1,
                    addressInfo.locality,
                    `${addressInfo.administrative_area_level_1} - ${addressInfo.postal_code}`,
                    addressInfo.country
                  ]
                  .filter(Boolean)
                  .join(', ')
                }}
                </p>
              </div>

      <!-- Buttons with OR separator -->
      <div class="d-flex flex-column align-items-center">
        <div class="w-100 mb-2">
          <button class="btn btn-red btn-block" @click="goToForm">Confirm Location</button>
        </div>
        <div v-if="bannerPlaceHolderForEditManuallyButton">
          <div class="my-2" style="font-weight: bold;">OR</div>
          <div class="text-danger font-weight-bold" style="cursor: pointer;"  @click="goToFormmanually">Edit Address Manually</div>
        </div>
      </div>
    </div>
            </div>

            <div v-else>
              <form id="editAdd" method="POST" action="" v-on:submit.prevent="updateAddr" enctype="form-data">
              <div class="modal-header">
                <h5 class="m-0">Edit Address</h5>
                <div class="closebtn" @click="$emit('close')">X</div>
              </div>
              <div v-if="locationInfo && !entermanually" style="border: 1px solid whitesmoke; margin-bottom:4px ; margin-top: 4px;" class="text-left p-1 rounded shadow-sm bg-white" >
                  <div class="d-flex align-items-center mb-2" style="gap: 8px;">
                    <img :src="pinDropIcon" alt="Map Marker" style="width: 12px; height: 16px;" />
                    <strong class="h6 m-0">
                    {{
                      (addressInfo.route && addressInfo.route.toLowerCase() !== 'unnamed road' ? addressInfo.route : '') ||
                      addressInfo.sublocality_level_1 ||
                      addressInfo.sublocality_level_2 ||
                      addressInfo.sublocality_level_3 ||
                      addressInfo.locality ||
                      addressInfo.administrative_area_level_1 ||
                      addressInfo.administrative_area_level_2 ||
                      addressInfo.administrative_area_level_3 ||
                      'Area Name'
                    }}
                  </strong>
                    <!-- <strong class="h6 m-0">{{ addressInfo.route || addressInfo.sublocality_level_1 || addressInfo.sublocality_level_2 || addressInfo.sublocality_level_3 || addressInfo.locality || addressInfo.administrative_area_level_1 || addressInfo.administrative_area_level_2 || addressInfo.administrative_area_level_3 || 'Area Name' }}</strong> -->
                  </div>
                  <p class="text-muted px-2 mb-0" style="line-height: 1.4;">
                    {{
                      [
                        addressInfo.sublocality_level_3,
                        addressInfo.sublocality_level_2,
                        addressInfo.sublocality_level_1,
                        addressInfo.locality,
                        `${addressInfo.administrative_area_level_1} - ${addressInfo.postal_code}`,
                        addressInfo.country
                      ]
                      .filter(Boolean)
                      .join(', ')
                    }}
                    </p>
                </div>
              <div class="modal-body">
                
                <!-- <div class="form-group row" :class="{error: validation.hasError('firstname')}">
                  <div class="col-sm-6">
                    <input type="text" class="form-control inmarginbtm" :placeholder="getAddressLabel(countryId,'firstName')" v-model="firstname" maxlength="32" @keydown="validateName" @paste="handleNamePaste" required>
                    <div class="message">{{ validation.firstError('firstname') }}</div>
                  </div>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'lastName')" v-model="lastname" maxlength="32" @keydown="validateName" @paste="handleNamePaste" required>
                  </div>
                </div> -->
                <div class="form-group row" :class="{error: validation.hasError('address1')}">
                  <div class="col-sm-12">
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="getAddressLabel(countryId,'address1')"
                      v-model="addressModel"
                      :maxlength="showMap || lat || lng  ? 200 : 35"

                    />
                    <div class="message">{{ validation.firstError('address1') }}</div>
                  </div>
                </div>
                <div v-if="bannerPlaceHolderForFloorFieldDisplay" class="form-group row">
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Floor"
                    v-model="floor"
                    maxlength="200"
                    name="floor"
                  />
                </div>
              </div>

                <div class="form-group row" :class="{error: validation.hasError('address2')}">
                  <div class="col-sm-12">
                    <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'address2')" v-model="address2"
                           maxlength="35">
                    <div class="message">{{ validation.firstError('address2') }}</div>
                  </div>
                </div>
                <div v-if="isSelectedCountryIndia" class="form-group row">
                  <div class="col-sm-12">
                    <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'address3')" v-model="address3"
                           maxlength="35">
                  </div>
                </div>
                <div class="row" v-if="!isSelectedCountryUAE">
                  <div class="col-sm-6" :class="{ error: validation.hasError('postcode') }">
                  <div class="form-group">
                    <input
                      name="postcode"
                      class="form-control"
                      v-on:keydown="validatePinCode($event, postcodeLength, countryId)"
                      @paste="handlePostPaste($event, countryId)"
                      :placeholder="getAddressLabel(countryId, 'postcode', countryId)"
                      v-model="postcode"
                      :maxlength="postcodeLength"
                    />
                    
                    <!-- Validation error from your validation lib -->
                    <div class="message text-danger">
                      {{ validation.firstError('postcode') }}
                    </div>
                    <div class="message text-warning" v-if="postcodeMismatch && !entermanually && !validation.hasError('postcode')">
                      Entered pincode does not match the map location. Please review. 
                    </div>
                  </div>
                </div>

                  <div v-if="isSelectedCountryIndia" class="col-sm-6" :class="{error: validation.hasError('city')}">
                    <div class="form-group">
                      <input disabled type="text" class="form-control" :placeholder="getAddressLabel(countryId,'city')" v-model="city" maxlength="32" @keydown="validateName" @paste="handleNamePaste">
                      <div class="message">{{ validation.firstError('city') }}</div>
                    </div>
                  </div>
                  <div v-if="!isSelectedCountryIndia" class="col-sm-6" :class="{error: validation.hasError('city')}">
                    <div class="form-group">
                      <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'city')" v-model="city" maxlength="32" @keydown="validateName" @paste="handleNamePaste">
                      <div class="message">{{ validation.firstError('city') }}</div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6" :class="{error: validation.hasError('countryId')}">
                    <div class="form-group">
                      <select 
                        name="countrySelectBox" 
                        class="form-control" 
                        :class="{ 'no-appearance': isSelectedCountryIndia }"
                        :placeholder="getAddressLabel(countryId,'countryId')" 
                        v-model="countryId" 
                        @change="getCountryStates(); selectZone(countryId)" 
                        required
                        :disabled="isSelectedCountryIndia"
                      >
                        <option value="0" selected>Select Country</option>
                        <option v-for="con in country_detail_data" :value="con.id">
                          {{ con.name }}
                        </option>
                      </select>
                      <div class="message">{{ validation.firstError('countryId') }}</div>
                    </div>
                  </div>
                  <div class="col-sm-6" :class="{error: validation.hasError('zone_id')} && submitted">
                    <div class="form-group">
                      <select 
                        class="form-control" 
                        :class="{ 'no-appearance': isSelectedCountryIndia }"
                        :placeholder="getAddressLabel(countryId,'zone_id')" 
                        v-model="zone_id" 
                        required
                        :disabled="isSelectedCountryIndia"
                      >
                        <option value="0" selected>{{`Select ${getAddressLabel(countryId,'zone_id')}`}}</option>
                        <option v-for="zn in zones" :value="zn.id">
                          {{ zn.name }}
                        </option>
                      </select>
                      <div class="message" v-if="validation.firstError('zone_id') && submitted">{{ validation.firstError('zone_id') }}</div>
                    </div>
                  </div>
                </div>

                 <div class="form-group row" :class="{error: validation.hasError('city')} && submitted" v-if="isSelectedCountryUAE">
                  <div class="col-sm-12">
                    <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'city')" v-model="city" maxlength="32" @keydown="validateName" @paste="handleNamePaste">
                    <div class="message" v-if="validation.hasError('city') && submitted">{{ validation.firstError('city') }}</div>
                  </div>
                </div>
                <!-- <div class="form-group row">
                  <div class="col-sm-12" :class="{error: validation.hasError('phone_no')}">
                    <div class="country-phone-code">
                      <select name="countrySelectBox" class="form-control country-code" v-model="countryCode">
                        <option v-for="con in country_detail_data" :key="con.id" :value="con.country_code">
                          +{{ con.country_code }}
                        </option>
                      </select>
                      <input type="text" class="form-control" :placeholder="getAddressLabel(countryId,'phone_no')" value="" v-model="phone_no" :maxlength="getPhonelength(countryId, countries)">
                    </div>
                    <div class="message">{{ validation.firstError('phone_no') }}</div>
                  </div>
                </div> -->
                <div>
                <h5>Contact Details</h5>  
                <div class="form-group row" :class="{ error: validation.hasError('firstname') || validation.hasError('lastname') }">
                    <div class="col-sm-12">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Name*"
                        v-model="fullName"
                        maxlength="64"
                        name="fullName"
                        @keydown="validateName"
                        @paste="handleNamePaste"
                        required
                      />
                      <div class="message" v-if="validation.firstError('firstname')">{{ validation.firstError('firstname') }}</div>
                      <div class="message" v-if="validation.firstError('lastname')">{{ validation.firstError('lastname') }}</div>
                    </div>
                  </div>
                  
                  <!-- Phone Number Field (Full width: col-sm-12) -->
                  <div class="form-group row" :class="{ error: validation.hasError('phone_no') }">
                    <div class="col-sm-12">
                      <div class="country-phone-code">
                        <select name="countrySelectBox" class="form-control country-code" :class="{ 'no-appearance': isSelectedCountryIndia }" v-model="countryCode">
                          <option v-for="con in country_detail_data" :key="con.id" :value="con.country_code">
                            +{{ con.country_code }}
                          </option>
                        </select>
                        <input
                          type="text"
                          class="form-control"
                          name="phone_no"
                          :placeholder="getAddressLabel(countryId, 'phone_no')"
                          @keydown="phoneNumberUpdate($event)"
                          :maxlength="getPhonelength(countryId, countries)"
                          v-model="phone_no"
                        />
                      </div>
                      <div class="message">{{ validation.firstError('phone_no') }}</div>
                    </div>
                  </div>
                  
                  <!-- Email Field (Full width: col-sm-12) -->
                  <div v-if="isNewUser && !(getUser && getUser.email)" class="form-group row" :class="{ error: validation.hasError('email') }">
                    <div class="col-sm-12">
                      <input
                        type="text"
                        class="form-control"
                        name="email"
                        :placeholder="getAddressLabel(countryId, 'email')"
                        maxlength="95"
                        v-model="email"
                      />
                      <div class="message">{{ validation.firstError('email') }}</div>
                    </div>
                  </div>
                </div>
                <p style="font-size: 16px; font-weight: 500; font-family: 'Montserrat', sans-serif;margin-bottom: 4px;">Save Address As</p>  
                <div>
                <button
                  v-for="(item, index) in buttons"
                  :key="item.value"
                  type="button"
                  class="location-btn"
                  :class="{ selected: selected === item.value }"
                  @click="selectAddressType(item.value)"
                >
                  {{ item.label }}
                </button>
              </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="is_default"> Save This As Default Address
                  </label>
                </div>
              </div>
              <div class="modal-footer">
                <div class="row">
                  <div class="col-md-6 col-6">
                    <button type="button" class="btn btn-secondary btn-block" @click="$emit('close')">Cancel</button>
                  </div>
                  <div class="col-md-6 col-6">
                    <button type="submit" class="btn btn-red btn-block">Save</button>
                  </div>
                </div>
              </div>
            </form>
            </div>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
/* global google */
  var $ = require('jquery')
  window.jQuery = $

  import SimpleVueValidation from 'simple-vue-validator'
  import Vue from 'vue'
  var Validator = SimpleVueValidation.Validator
  import {mapGetters} from 'vuex'
  import pinDropIcon from '@/assets/images/pin_drop_24px.png'
  import crooshair from '@/assets/images/crosshairs-gps.svg'

  import nameValidationMixin from '../../mixins/validationMixin'
  import { getAddressLabel } from '../../assets/js/common'
  import {getPhonelength} from '../../assets/js/utils'
  import debounce from 'lodash/debounce'

  export default {
    mixins: [nameValidationMixin],
    props: ['userAddr', 'procountry', 'getzone', 'upAddFun', 'callerComp', 'proceedFunc', 'checkAreaServiceability'],
    data () {
      return {
        selected: null,
        crooshair,
        entermanually: false,
        activeField: 'flat',
        buttons: [
          { label: 'Home', value: 1 },
          { label: 'Work', value: 2 },
          { label: 'Other', value: 3 }
        ],
        pinDropIcon,
        postcodeMismatch: false,
        placesService: null,
        autocompleteService: null,
        predictions: [],
        inputValue: '',
        isInitialized: false,
        showMap: true,
        locationInfo: null,
        googleMapsKey: 'AIzaSyDjYuXiK3cLxlZrekHRGzPra4Bw48dtQcs',
        step: 1,
        // addr: {user_id: '', firstname: '', lastname: '', address1: '', address2: '', address3: '', postcode: '', city: '', zone_id: '',country_id:'', phone_no: ''},
        loggedin_user_id: this.userAddr.user_id,
        editForm: {},
        firstname: this.userAddr.firstname,
        address_id: this.userAddr.id,
        lastname: this.userAddr.lastname,
        address1: this.userAddr.address1 || '',
        address2: this.userAddr.address2,
        address3: this.userAddr.address3,
        address4: [],
        postcode: this.userAddr.postcode,
        mapSelectedPostalCode: [],
        floor: this.userAddr.floor,
        flat: this.userAddr.flat || '',
        city: this.userAddr.city,
        zone_id: this.userAddr.zone_id,
        countryId: this.userAddr.country_id,
        countryCode: this.userAddr.country_code,
        phone_no: this.userAddr.phone_no,
        is_default: this.userAddr.is_default,
        zonefor: '', // this.getzone
        autofillData: {},
        timeout: null,
        getAddressLabel: getAddressLabel,
        getPhonelength: getPhonelength
      }
    },
    created: function () {
      if (this.country_detail_data.country_code) {
        this.countryCode = this.country_detail_data.country_code
      }
      this.$store.commit('SET_GLOBAL_SETTING_KEYS', ['pincode_length_validation', 'SHOW_WEB_MENU_WOMEN', 'SHOW_WEB_MENU_MEN', 'SHOW_WEB_MENU_KIDS'])
      this.$store.dispatch('ZONES', this.countryId)
      this.postcodeLength
    },
    methods: {
      recenterMarkerToCurrentLocation () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const userLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }

              if (this.mapInstance && this.marker) {
                this.mapInstance.setCenter(userLocation)
                this.marker.setPosition(userLocation)
                this.getAddressFromCoords(userLocation.lat, userLocation.lng)
              }
            },
            (error) => {
              console.error('Geolocation error:', error)
              let message = 'Unable to get your location.'
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  message = 'Location permission was denied.'
                  break
                case error.POSITION_UNAVAILABLE:
                  message = 'Location information is unavailable.'
                  break
                case error.TIMEOUT:
                  message = 'The request to get your location timed out.'
                  break
              }
              alert(message)
            },
            {
              enableHighAccuracy: true,
              timeout: 5000,
              maximumAge: 0
            }
          )
        } else {
          // alert("Geolocation is not supported by this browser.")
        }
      },
      selectAddressType (value) {
        this.selected = value
      },
      getAddressLabel (countryId, label) {
        return getAddressLabel(countryId, label)
      },
      initializePlacesService () {
        if (typeof google !== 'undefined' && google.maps) {
          this.placesService = new google.maps.places.PlacesService(document.createElement('div')) // Create a dummy div to initialize places service
        } else {
        }
      },
      onInputChange (event) {
        const query = event.target.value

        if (query.length < 1) {
          this.predictions = []
          return
        }

        this.debouncedHandleAutocomplete(query)
      },
      handleAutocomplete (query) {
        if (!this.autocompleteService) {
          this.predictions = []
          return
        }

        const request = {
          input: query,
          language: 'en'
        }

        const fallbackLocation = { lat: this.lat, lng: this.lng }
        const userLat = this.lat || fallbackLocation.lat
        const userLng = this.lng || fallbackLocation.lng

        request.location = new google.maps.LatLng(userLat, userLng)
        request.radius = 5000
        request.strictBounds = false

        this.autocompleteService.getPlacePredictions(request, (predictions, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
            this.predictions = []
            return
          }

          if (this.userLocation) {
            predictions.sort((a, b) => {
              const distanceA = a.distanceMeters || (a.distance && typeof a.distance === 'number' ? a.distance : Infinity)
              const distanceB = b.distanceMeters || (b.distance && typeof b.distance === 'number' ? b.distance : Infinity)
              return distanceA - distanceB
            })
          }

          this.predictions = predictions
        })
      },
      selectSuggestion (prediction) {
        this.inputValue = prediction.description
        this.predictions = []
        // Fetch the place details using PlacesService to get lat/lng
        this.placesService.getDetails({ placeId: prediction.place_id }, (place, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            // Extract latitude and longitude from the place details
            const lat = place.geometry.location.lat()
            const lng = place.geometry.location.lng()
            // Call your getAddressFromCoords method to get the address from lat, lng
            this.getAddressFromCoords(lat, lng)
            if (this.marker) {
              this.marker.setPosition(new google.maps.LatLng(lat, lng)) // Update marker position
            } else {
            // Create a new marker if it doesn't exist
              this.marker = new google.maps.Marker({
                position: { lat, lng },
                map: this.mapInstance,
                draggable: true
              })
            }

      // Recenter map to the new marker location
            this.mapInstance.setCenter({ lat, lng })
            this.mapInstance.setZoom(15)
            // Optionally, you can store the lat and lng in Vuex or elsewhere
            this.lat = lat
            this.long = lng
          } else {
          }
        })
      },
      getZoneName (zoneid) {
        const zone = this.zones.find(z => z.id === zoneid)
        return zone ? zone.name : '' // Return an empty string if zone is not found
      },
      getAddressFromCoords (lat, lng) {
        fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&language=en&key=${this.googleMapsKey}`)
          .then(response => response.json())
          .then(data => {
            if (data.status === 'OK' && data.results.length > 0) {
              const allComponents = data.results.flatMap(result => result.address_components)
              const getComponent = (type) => {
                let match = allComponents.find(c => c.types.includes(type) && /^[\x00-\x7F]*$/.test(c.long_name))
                if (match) return match.long_name
                match = allComponents.find(c => c.types.includes(type))
                return match ? match.long_name : ''
              }

              const allPincodes = [
                ...new Set(
                  allComponents
                    .filter(c => c.types.includes('postal_code'))
                    .map(c => c.long_name)
                )
              ]

              const addressData = {
                fullAddress: data.results[0].formatted_address,
                route: getComponent('route'),
                sublocality_level_3: getComponent('sublocality_level_3'),
                sublocality_level_2: getComponent('sublocality_level_2'),
                sublocality_level_1: getComponent('sublocality_level_1'),
                administrative_area_level_3: getComponent('administrative_area_level_3'),
                administrative_area_level_2: getComponent('administrative_area_level_2'),
                administrative_area_level_1: getComponent('administrative_area_level_1'),
                locality: getComponent('locality'),
                postal_code: getComponent('postal_code'),
                country: getComponent('country')
              }

              this.locationInfo = {
                lat,
                lng,
                address: addressData.fullAddress
              }

              this.addressInfo = addressData
              this.mapSelectedPostalCode = allPincodes
              this.postcode = addressData.postal_code
              // this.address4 = [
              //   addressData.sublocality_level_1,
              //   addressData.sublocality_level_2,
              //   addressData.sublocality_level_3
              // ]
              // .filter(item => item && item.toLowerCase() !== 'unnamed road')
              // .join(', ')
              let l1 = addressData.sublocality_level_1
              let l2 = addressData.sublocality_level_2
              let l3 = addressData.sublocality_level_3

              // Remove 'unnamed road'
              l1 = l1 && l1.toLowerCase() !== 'unnamed road' ? l1 : null
              l2 = l2 && l2.toLowerCase() !== 'unnamed road' ? l2 : null
              l3 = l3 && l3.toLowerCase() !== 'unnamed road' ? l3 : null

              // Remove duplicates
              if (l1 && l2 && l1 === l2) l2 = null
              if (l2 && l3 && l2 === l3) l3 = null

              this.address4 = [l1, l2, l3].filter(Boolean).join(', ')
              this.address2 = (addressData.route && addressData.route.toLowerCase() !== 'unnamed road' && addressData.route) ||
              addressData.sublocality_level_1 ||
              addressData.sublocality_level_2 ||
              addressData.sublocality_level_3 ||
              addressData.locality ||
              addressData.administrative_area_level_1 ||
              addressData.administrative_area_level_2 ||
              addressData.administrative_area_level_3
              // this.address2 = addressData.route || addressData.sublocality_level_1 || addressData.sublocality_level_2 || addressData.sublocality_level_3 || addressData.locality || addressData.administrative_area_level_1 || addressData.administrative_area_level_2 || addressData.administrative_area_level_3

              // Vuex commits
              this.$store.commit('setLat', lat)
              this.$store.commit('setLng', lng)
            } else {
              console.error('Geocoding failed:', data.status)
            }
          })
          .catch(error => {
            console.error('Geocoding error:', error)
          })
      },
      loadGoogleMaps () {
        if (typeof google !== 'undefined') {
          this.initMap()
          this.initializePlacesService()
          return
        }

        const script = document.createElement('script')
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.googleMapsKey}&callback=initMap&language=en`
        script.async = true
        script.defer = true
        window.initMap = this.initMap
        document.head.appendChild(script)
      },
      initMap () {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const userCoords = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              }
              this.createMap(userCoords)
            },
            (error) => {
              console.log('Error getting location:', error)
              // this.createMap({ lat: 19.0760, lng: 72.8777 })
            }
          )
        } else {
          // this.createMap({ lat: 19.0760, lng: 72.8777 })
        }
      },
      createMap (centerCoords) {
        // Use this.address if valid, else fallback to centerCoords
        const hasAddressCoords = this.address && isFinite(parseFloat(this.address.latitude)) && isFinite(parseFloat(this.address.longitude))

        const mapCenter = hasAddressCoords ? {
          lat: parseFloat(this.address.latitude),
          lng: parseFloat(this.address.longitude)
        }
        : (
              isFinite(centerCoords.lat) && isFinite(centerCoords.lng)
                ? centerCoords
                : { lat: 0, lng: 0 } // fallback default
            )

        // Initialize map
        this.mapInstance = new google.maps.Map(this.$refs.mapContainer, {
          center: mapCenter,
          zoom: 12,
          disableDefaultUI: true,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_CENTER
          }
        })

        // Marker
        this.marker = new google.maps.Marker({
          position: mapCenter,
          map: this.mapInstance,
          draggable: true
        })

        // Map click to move marker
        this.mapInstance.addListener('click', (event) => {
          const clickedLocation = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
          }
          this.marker.setPosition(clickedLocation)
          this.mapInstance.panTo(clickedLocation)
          this.getAddressFromCoords(clickedLocation.lat, clickedLocation.lng)
        })

        // Drag end
        this.marker.addListener('dragend', () => {
          const newPosition = this.marker.getPosition()
          const lat = newPosition.lat()
          const lng = newPosition.lng()
          this.mapInstance.setCenter(newPosition)
          this.getAddressFromCoords(lat, lng)
        })

        // Reverse geocoding
        this.getAddressFromCoords(mapCenter.lat, mapCenter.lng)

        // Autocomplete
        const input = document.getElementById('autocomplete')
        if (input && google.maps.places) {
          // const autocomplete = new google.maps.places.Autocomplete(input)
          // autocomplete.bindTo('bounds', this.mapInstance)

          // autocomplete.addListener('place_changed', () => {
          //   const place = autocomplete.getPlace()
          //   if (!place.geometry || !place.geometry.location) return

          //   const location = {
          //     lat: place.geometry.location.lat(),
          //     lng: place.geometry.location.lng()
          //   }

          //   this.mapInstance.setCenter(location)
          //   this.mapInstance.setZoom(15)
          //   this.marker.setPosition(location)
          //   this.getAddressFromCoords(location.lat, location.lng)
          // })
        }
      },
      goBackToStepOne () {
        this.loadGoogleMaps()
        this.showMap = true
      },
      goToForm () {
        this.showMap = false
        if (!this.entermanually && this.addressInfo) {
          this.address2 = (this.addressInfo.route && this.addressInfo.route.toLowerCase() !== 'unnamed road' ? this.addressInfo.route : '') ||
          this.addressInfo.sublocality_level_1 ||
          this.addressInfo.sublocality_level_2 ||
          this.addressInfo.sublocality_level_3 ||
          this.addressInfo.locality ||
          this.addressInfo.administrative_area_level_1 ||
          this.addressInfo.administrative_area_level_2 ||
          this.addressInfo.administrative_area_level_3 ||
          'Street Name'
        }
        this.flat = this.address.flat
      },
      goToFormmanually () {
        if (!this.showMap) {
          this.activeField = 'address1'
        }
        if (this.isSelectedCountryUAE) {
          this.city = this.address.city
          this.zone_id = this.address.zone_id
          this.countryId = this.address.country_id
        }
        this.mapSelectedPostalCode = []
        this.address4 = []
        this.postcode = this.address.postcode
        this.address2 = this.address.address2
        this.$store.commit('setLat', null)
        this.$store.commit('setLng', null)
        this.showMap = false
        this.entermanually = true

        const trimmed = (this.address.flat || this.address.address1 || '').substring(0, 35)
        this.flat = trimmed
        this.address1 = trimmed
      },
      selectZone () {
        if (this.countryId !== 0) {
          // this.axios.post('api/v1/address/get-zone', {country_id: this.countryId}, {headers: {Authorization: 'Bearer ' + this.$localStorage.get('vue-authenticate.access_token')}, crossDomain: true, withCredentials: true}).then((response) => {
          //   this.zonefor = response.data
          //   this.zone_id = 0
          // })
        } else {
          this.zone_id = 0
        }
      },
      updateAddr () {
        var this_ = this
        this_.submitted = true

        if (this_.isPostcodeValidating) return
        this_.submitted = true

        if (this_.postcodeMismatch) {
          return
        }

        this_.$validate().then((success) => {
          if (success) {
            var data = {
              firstname: this_.fullName,
              address_id: this_.userAddr.id || '',
              lastname: '.',
              // address1: this.entermanually ? this.flat : this_.lat || this_.lng ? this_.addressInfo.sublocality_level_1 || this_.addressInfo.sublocality_level_2 || this_.addressInfo.sublocality_level_3 || this_.addressInfo.locality || this_.addressInfo.administrative_area_level_1 || this_.addressInfo.administrative_area_level_2 || this_.addressInfo.administrative_area_level_3 : this_.address1,
              // address1: this.entermanually ? this.flat : (this_.lat || this_.lng ? [this_.addressInfo.sublocality_level_1, this_.addressInfo.sublocality_level_2, this_.addressInfo.sublocality_level_3, this_.addressInfo.locality, this_.addressInfo.administrative_area_level_1, this_.addressInfo.administrative_area_level_2, this_.addressInfo.administrative_area_level_3].find(val => val && val !== 'Unnamed Road') : this_.address1),
              address1: this.entermanually ? (this.flat && this.flat.trim() !== '' ? this.flat.trim() : (this.address1 || '')) : ((this.lat || this.lng) ? [this.addressInfo.sublocality_level_1, this.addressInfo.sublocality_level_2, this.addressInfo.sublocality_level_3, this.addressInfo.locality, this.addressInfo.administrative_area_level_1, this.addressInfo.administrative_area_level_2, this.addressInfo.administrative_area_level_3].find(val => val && val !== 'Unnamed Road') || '' : (this.address1 || '')),
              address2: this_.address2,
              address3: this_.address3,
              address4: this_.address4,
              postcode: this_.isSelectedCountryUAE ? '00000' : this_.postcode,
              city: this_.city,
              zone_id: this_.zone_id,
              country_id: this_.countryId,
              country_code: this_.countryCode,
              phone_no: this_.phone_no,
              flat: this.entermanually ? '' : (this.lat && this.lng ? `${(this.flat && this.flat.trim() !== '' ? this.flat : (this.address.flat && this.address.flat.trim() !== '' ? this.address.flat : this.address1))}${this.floor ? ', ' + this.floor : ''}` : (this.flat && this.flat.trim() !== '' ? this.flat : (this.address.flat && this.address.flat.trim() !== '' ? this.address.flat : this.address1 || ''))),
              is_default: this_.is_default,
              zonefor: this_.zonefor,
              address_type: this_.selected,
              // flat: (this_.lat || this_.lng) && this_.entermanually === false ? `${this_.flat && this_.flat.trim() !== '' ? this_.flat : (this_.address.flat && this_.address.flat.trim() !== '' ? this_.address.flat : this_.address1)}${this_.floor ? ', ' + this_.floor : ''}` : (this_.flat && this_.flat.trim() !== '' ? this_.flat : (this_.address.flat && this_.address.flat.trim() !== '' ? this_.address.flat : this_.address1 || '')),
              location: {
                latitude: this_.lat ? String(this_.lat) : '',
                longitude: this_.lng ? String(this_.lng) : ''
              },
              action: 'put'
            }
            this.$store.dispatch('UPDATE_ADDRESS', data)
            .then((res) => {
              this.$store.commit('GTAG_EVENT', {eventName: 'add_shipping_info', payload: {value: this.getUserTatvicBuyNowItem && this.getUserTatvicBuyNowItem[0].price || 'NA', items: this.getUserTatvicBuyNowItem}})
              this_.$parent.editModal = false
              if (res && this.callerComp === 'buyNow' && this.checkAreaServiceability) {
                this.checkAreaServiceability()
              }
            })
            .catch(error => {
              Vue.toasted.show(error.data.title, {
                theme: 'primary',
                className: 'toasted-customred',
                position: 'top-right',
                duration: 5000
              })
            })
          }
        })
      },
      getLatLongAddress: function () {
        this.$store.commit('GTAG_EVENT', {eventName: 'useMyCurrentLocation_click', payload: {}})
        navigator.geolocation.getCurrentPosition(pos => {
          let myLatlng = {}
          myLatlng.latitude = pos.coords.latitude
          myLatlng.longitude = pos.coords.longitude
          this.$store.dispatch('GET_GOOGLE_LOCATION_ADDRESS_DATA', myLatlng).then(response => {
            if (response.status === 'success' && response.result && response.result.length > 0) {
              let parts = response.result[0].address_components
              parts.forEach(part => {
                if (part.types.includes('postal_code')) {
                  this.autofillData.postalCode = part.long_name
                }
                if (part.types.includes('administrative_area_level_1')) {
                  this.autofillData.politicalState = part.long_name
                }
                if (part.types.includes('administrative_area_level_2')) {
                  this.autofillData.politicalCity = part.long_name
                }
                if (part.types.includes('street_number') || part.types.includes('route') || part.types.includes('premise') || part.types.includes('sublocality_level_2')) {
                  this.autofillData.streetName = part.long_name
                }
                if (part.types.includes('neighborhood') || part.types.includes('landmark') || part.types.includes('sublocality_level_1')) {
                  this.autofillData.landMark = part.long_name
                }
              })
              this.postcode = this.autofillData.postalCode ? this.autofillData.postalCode : ''
              if (!this.isSelectedCountryUAE) {
                this.city = this.autofillData.politicalCity ? this.autofillData.politicalCity : ''
              }
              this.address2 = this.autofillData.streetName ? this.autofillData.streetName : ''
              this.address3 = this.autofillData.landMark ? this.autofillData.landMark : ''
              let tempZoneData = this.zones && this.zones.filter((zn) => {
                return zn.name === this.autofillData.politicalState
              })
              this.zone_id = tempZoneData[0].id
            }
          })
        }, err => {
          Vue.toasted.show(err.message, {theme: 'primary', className: 'toasted-customred', position: 'top-right', duration: 5000})
        })
      },
      getCountryStates: function () {
        this.postcode = ''
        this.zone_id = 0
        this.$store.dispatch('ZONES', this.countryId)
        this.zone_id = this.address.zone_id
        this.postcodeLength
      }
    },
    validators: {
      firstname: function (value) {
        return Validator.value(value).required()
      },
      address1: function (value) {
        const maxLen = this.showmap || this.lat || this.lng || !this.entermanually ? 200 : 35
        return Validator.value(value).required().minLength(4).maxLength(maxLen)
        // return Validator.value(value).required().minLength(4).maxLength(200)
      },
      address2: function (value) {
        return (this.isSelectedCountryIndia || this.isSelectedCountryUK || this.isSelectedCountryUAE) && Validator.value(value).required()
      },
      postcode: function (value) {
        return !this.isSelectedCountryUAE && Validator.value(value).required().custom(function () {
          var country = $('#editAdd').find('[name="countrySelectBox"]').val()
          var regex = ''
          if (country === '99') {
            regex = new RegExp(/^[1-9][0-9]{5}$/)
            if (!regex.test(value)) {
              return 'Invalid Pincode'
            }
          } else if (country === '21') {
            regex = new RegExp(/^[1-9]{1}[0-9]{3}$/) //  Belgium
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '203') {
            regex = new RegExp(/^(s-|S-){0,1}[0-9]{3}\s?[0-9]{2}$/) //  Sweden
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '57') {
            regex = new RegExp(/^([D-d][K-k])?( |-)?[1-9]{1}[0-9]{3}$/) //  Denmark
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '195') {
            regex = new RegExp(/^([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}$/) //  Spain
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '150') {
            regex = new RegExp(/^[1-9][0-9]{3}\s?([a-zA-Z]{2})?$/) //  Netherlands
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '105') {
            regex = new RegExp(/^(V-|I-)?[0-9]{5}$/) //  Italy
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '13') {
            regex = new RegExp(/^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/) //  Austrelia
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '223') {
            regex = new RegExp(/(^\d{5}$)|(^\d{5}-\d{4}$)/) //  USA
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '222') {
            regex = new RegExp(/^[A-Z0-9 ]+$/i) //  UK
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '81') {
            regex = new RegExp(/^\b((?:0[1-46-9]\d{3})|(?:[1-357-9]\d{4})|(?:[4][0-24-9]\d{3})|(?:[6][013-9]\d{3}))\b/) //  Germany
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '38') {
            regex = new RegExp(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/) //  Canada
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else if (country === '74') {
            regex = new RegExp(/^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/) //  France
            if (!regex.test(value)) {
              return 'Invalid postal code'
            }
          } else {

          }
        })
      },
      city: function (value) {
        return Validator.value(value).required()
      },
      zone_id: function (value) {
        const isSelectedCountryUK = this.isSelectedCountryUK
        const isSelectedCountryUAE = this.isSelectedCountryUAE
        return Validator.value(value).required().custom(function () {
          if (value === 0) {
            if (isSelectedCountryUK) return 'Please select county'
            if (isSelectedCountryUAE) return 'Please select emirate'
            return 'Please select state'
          }
        })
      },
      countryId: function (value) {
        return Validator.value(value).required().custom(function () {
          if (value === 0) {
            return 'Please select state'
          }
        })
      },
      phone_no: function (value) {
        const filterCountry = this.countries.find(obj => parseInt(obj.id) === parseInt(this.countryId))
        const countryPhoneLength = filterCountry.phone_no_length
        const countryPhoneMinLength = filterCountry && filterCountry.phone_no_min_length || 10
        // Validator.value(value).required().minLength(10).maxLength(10).digit('Must be number')
        let regexMobile
        if (this.isSelectedCountryUK) {
          regexMobile = /^[0-9]{10,11}$/
        } else if (this.isSelectedCountryUAE) {
          regexMobile = /^[1-9]{1}[0-9]{7,8}$/
        } else {
          regexMobile = /^[1-9]{1}[0-9]{9}$/
        }
        const isSelectedCountryUAE = this.isSelectedCountryUAE
        const isSelectedCountryUK = this.isSelectedCountryUK
        return Validator.custom(function () {
          if (isSelectedCountryUAE && value && value.trim().length < countryPhoneMinLength) return `Must have ${countryPhoneMinLength} digits at least.`
          if (isSelectedCountryUK && value && value.trim().length < countryPhoneMinLength) return `Must have ${countryPhoneMinLength} digits at least.`
          if (!isSelectedCountryUAE && !isSelectedCountryUK && value && value.trim().length < countryPhoneLength) return `Must have ${countryPhoneLength} digits at least.`
          if (!Validator.isEmpty(value)) {
            if (isSelectedCountryUAE && value.length < 8) return `Must have ${8} digits at least.`
            if (isSelectedCountryUK && value.length < 10) return `Must have ${10} digits at least.`
            if (!isSelectedCountryUAE && !isSelectedCountryUK && value.length < countryPhoneLength) {
              return `Must have ${countryPhoneLength} digits at least.`
            }
            if (!regexMobile.test(value)) {
              return 'Please enter valid mobile number.'
            }
          }
        })
      }
    },
    computed: {
      // addressModel: {
      //   get () {
      //     return this.flat || this.address1 || ''
      //   },
      //   set (value) {
      //     this.flat = value
      //     this.address1 = value
      //   }
      // },
      // addressModel: {
      //   get () {
      //     if (this.entermanually) {
      //       return (this.flat || '').substring(0, 35)
      //     }
      //     return this.flat || this.address1 || ''
      //   },
      //   set (value) {
      //     this.flat = value
      //     if (this.entermanually) {
      //       this.address1 = value
      //     }
      //   }
      // },
      addressModel: {
        get () {
          if (this.entermanually) {
            const flat = (this.flat || '').trim().substring(0, 35)
            return flat || (this.address1 || '').substring(0, 35)
          }
          return this.flat || this.address1 || ''
        },
        set (value) {
          this.flat = value
          if (this.entermanually) {
            this.address1 = value
          }
        }
      },
      ...mapGetters({bannerPlcaeHolderData: 'bannerPlcaeHolderData', address: 'address', lat: 'lat', lng: 'lng', countries: 'countries', user: 'user', zones: 'zones', globalBannerPlaceholder: 'globalBannerPlaceholder', getUserTatvicBuyNowItem: 'getUserTatvicBuyNowItem', country_detail_data: 'country_detail_data'}),
      zoneget: function () {
        var zn = this.zonefor
        return zn
      },
      bannerPlaceHolderForFloorFieldDisplay: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Cart Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_FLOOR_IN_ADDRESS_PAGE_WEB'.toLowerCase())
      },
      bannerPlaceHolderForEditManuallyButton: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Cart Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_EDIT_MANUALLY_ADDRESS_WEB'.toLowerCase())
      },
      bannerPlaceHolderForMapScreenDisplay: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Cart Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_MAP_LOCATION_PAGE_WEB'.toLowerCase())
      },
      bannerPlaceHolderForMapScreenDisplayUAE: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Cart Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_MAP_LOCATION_PAGE_UAE_WEB'.toLowerCase())
      },
      bannerPlaceHolderForMapScreenDisplayUK: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Cart Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_MAP_LOCATION_PAGE_UK_WEB'.toLowerCase())
      },
      bannerPlaceHolderForMapScreenDisplayUSA: function () {
        return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Cart Screen'.toLowerCase() && bannerData.status === true && bannerData.product_type.toLowerCase() === 'SHOW_MAP_LOCATION_PAGE_USA_WEB'.toLowerCase())
      },
      postcodeLength () {
        const pincode = this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData =>
        bannerData.is_active === true && bannerData.config_key === 'pincode_length_validation')
        if (this.countryId === 222) {
          return 8
        }
        if (pincode) {
          return pincode.value
        } else {
          return 6
        }
      },
      isSelectedCountryIndia () {
        return this.countryId ? parseInt(this.countryId) === 99 : false
      },
      isSelectedCountryUK () {
        return this.countryId ? parseInt(this.countryId) === 222 : false
      },
      isSelectedCountryUAE () {
        return this.countryId ? parseInt(this.countryId) === 221 : false
      },
      fullName: {
        get () {
          return `${this.firstname} ${this.lastname}`.trim()
        },
        set (value) {
          // Split the full name by spaces and assign first name and last name
          const parts = value.trim().split(/\s+/)
          this.firstname = parts[0] || ''  // First part is first name
          this.lastname = parts.slice(1).join(' ') || ''  // Remaining parts as last name
        }
      }
    },
    mounted: function () {
      if (this.bannerPlaceHolderForMapScreenDisplay) {
        this.activeField = 'flat'
      }
      if (!this.bannerPlaceHolderForMapScreenDisplay) {
        this.activeField = 'address1'
      }
      if (typeof google !== 'undefined' && google.maps && google.maps.places) {
        this.autocompleteService = new google.maps.places.AutocompleteService()
      }
      this.debouncedHandleAutocomplete = debounce(this.handleAutocomplete, 500)
      // if (this.bannerPlaceHolderForMapScreenDisplay == null || this.bannerPlaceHolderForMapScreenDisplay === undefined) {
      //   this.showMap = false
      // } else {
      //   this.showMap = true
      // }
      let banner

      if (this.isSelectedCountryUK) {
        banner = this.bannerPlaceHolderForMapScreenDisplayUK
      } else if (this.isSelectedCountryUAE) {
        banner = this.bannerPlaceHolderForMapScreenDisplayUAE
      } else if (!this.isSelectedCountryIndia &&
                !this.isSelectedCountryUAE &&
                !this.isSelectedCountryUK) {
        banner = this.bannerPlaceHolderForMapScreenDisplayUSA
      } else {
        banner = this.bannerPlaceHolderForMapScreenDisplay
      }

      this.showMap = banner != null
      if (!this.showMap) {
        this.entermanually = true
      }
      this.$nextTick(() => {
        if (this.showMap) {
          this.loadGoogleMaps()
        }
      })

      this.isInitialized = true
      return this.$store.getters.address
    },
    watch: {
      country_detail_data (newVal) {
        if (Array.isArray(newVal) && newVal.length > 0 && !this.countryCode) {
          this.countryCode = newVal[0].country_code
        }
      },
      addressModel (val) {
        this.$validate('address1')
      },
      address1 (value) {
        this.validateAddress('address1', value)
      },
      address2 (value) {
        this.validateAddress('address2', value)
      },
      address3 (value) {
        this.validateAddress('address3', value)
      },
      postcode () {
        const self = this
        if (self.isSelectedCountryUAE) {
          return
        }

        self.isPostcodeValidating = true
        clearTimeout(this.timeout)
        this.timeout = setTimeout(function () {
          const postcode = self.postcode || ''
          const isSixDigits = /^\d{6}$/.test(postcode)

          if (isSixDigits && Array.isArray(self.mapSelectedPostalCode) && self.mapSelectedPostalCode.length > 0) {
            self.postcodeMismatch = !self.mapSelectedPostalCode.includes(postcode)
          } else {
            self.postcodeMismatch = false
          }

          self.$validate('postcode').then((success) => {
            if (success) {
              self.$store.dispatch('GET_DELIVERY_DETAILS_FROM_PINCODE', { pincode: postcode }).then(res => {
                if (res && res.success) {
                  // self.city = res.data.city
                  self.city = res.data.city ? res.data.city.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : ''
                  const tempZoneData = self.zones.filter((zn) => zn.name === res.data.state)
                  self.zone_id = tempZoneData.length ? tempZoneData[0].id : null
                }
              })
            }
            self.isPostcodeValidating = false
          })
        }, 500)
      }

    }
  }
</script>
<style scoped="scoped">
.recenter-btn {
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 5;
  background-color: white;
  border: none;
  padding: 8px 10px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
  cursor: pointer;
  font-size: 20px;
}
.recenter-btn:focus {
  outline: none;
  box-shadow: none;
  border: none;
}
.no-appearance {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none;
  padding-right: 20px;   
}

.location-btn {
  padding: 2px 8px;
  margin: 5px;
  border-radius: 8px;
  border: 1px solid grey !important;
  cursor: pointer;
  opacity: 0.4; /* Make non-selected buttons semi-transparent */
  transition: opacity 0.3s ease;
}

.location-btn.selected {
  border: 3px solid black;
  opacity: 1; /* Fully visible */
}

    .address-type-btn.active {
      border: 2px solid #333;
    }
    .address-type-btn {
      border: none;
    }
.input-container {
  position: relative;
  width: 100%;
  max-width: 700px; /* adjust width as needed */
  margin: 0 auto;
}

.search-icon {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  color: #008080; /* Teal color like in your image */
  font-size: 20px;
  z-index: 10; /* Ensure the icon is above the input */
}

.search-input {
  width: 100%;
  padding: 10px 10px 10px 40px; /* left padding for icon space */
  border: 2px solid #008080; /* Teal border */
  border-radius: 2px;
  font-size: 16px;
  color: #008080;
  z-index: 5; /* Keep input below the icon */
}

/* Placeholder color */
.search-input::placeholder {
  color: #008080;
}

/* Suggestions list style */
.suggestions-list {
  list-style: none;
  padding: 0;
  margin-top: 4px;
  border: 1px solid #ccc;
  border-top: none;
  position: absolute;
  width: 100%;
  background: #fff;
  z-index: 100; /* Suggestions should be above the map */
}

/* Individual suggestion item */
.suggestion-item {
  padding: 10px;
  cursor: pointer;
  background: #fff;
}

/* Hover effect for suggestions */
.suggestion-item:hover {
  background: #F0F0F0;
}

  .modalcon {
    position: fixed;
    display: block;
    left: 0;
    z-index: 9998;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    overflow-x: hidden;
    overflow-y: auto;
    transition: opacity .3s ease;
  }

  .modal-mask { 
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
  }

  .closebtn {
    padding: 5px;
    font-weight: bold;
    cursor: pointer;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 550px;
    margin: 0px auto;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header {
    padding: 5px;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-footer {
    padding: 15px 5px 5px 5px;
  }

  .modal-body {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 36rem;
    margin: 20px 0 0px 0;
    padding: 5px;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }
  .svgControl{
    margin-right: 6px;
    vertical-align: middle;
  }
  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  @media screen and (max-width: 768px) {
    .modal-container {
      width: 85%;
    }
  }

  input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }
.country-phone-code {
  position: relative;
}
.country-phone-code .country-code {
  width: 65px;
  height: 39px !important;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-family: 'Source Sans Pro', sans-serif;
  border-color: #D9D9D9;
  border-right: 1px solid #eee;
  border-radius: 10px 0 0 10px;
  color: #58595b;
  padding: 0 5px;
}
.country-phone-code input {
  padding-left: 70px;
}
</style>



// WEBPACK FOOTER //
// editAddress.vue?61f5456c